import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <main data-testid="terms-page" className="pt-32 pb-24 bg-[#faf6ef] min-h-screen">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-[#b4462a] text-xs tracking-[0.3em] uppercase font-bold mb-4">Legal</div>
        <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] tracking-tight font-light mb-8 text-[#1e2a5a]">Terms &amp; Conditions</h1>
        <div className="rounded-3xl bg-white shadow-soft p-8 md:p-12 space-y-6 text-[#1a1a1a]/80 leading-[1.8]">
          <p className="text-sm text-[#1a1a1a]/55 italic">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using the Indus Art &amp; Emporium website (indusart.in), you agree to be bound by these Terms and Conditions. This is placeholder content — replace with your final legal copy before go-live.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">2. Business Scope</h2>
            <p>Indus Art &amp; Emporium is a wholesale manufacturer and exporter of handmade block-print home textiles based in Jaipur, India. This website is intended for wholesale trade buyers, interior designers, and retail partners. Prices are quoted privately based on order volume, design path, and destination.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">3. Quotes &amp; Orders</h2>
            <p>Quotes issued by Indus Art are valid for 30 days unless otherwise stated. Purchase orders become binding upon written confirmation and receipt of advance payment as agreed. Lead times of 30–90 days apply depending on volume and design path.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">4. Intellectual Property</h2>
            <p>All library designs remain the property of Indus Art &amp; Emporium. Client-supplied artwork remains the property of the client. Indus Art exclusive designs cannot be reproduced or shared without written permission.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">5. Defects &amp; Returns</h2>
            <p>Defects identified within 5 business days of receipt are investigated and resolved through rework, replacement, or credit per the agreed PO terms.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">6. Limitation of Liability</h2>
            <p>Placeholder text. Indus Art's liability is limited to the value of the relevant purchase order. Consequential damages are excluded.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">7. Governing Law</h2>
            <p>These terms are governed by the laws of India. Disputes are subject to the exclusive jurisdiction of courts in Jaipur, Rajasthan.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#1e2a5a] mb-3">8. Contact</h2>
            <p>Questions about these Terms? <Link to="/contact" className="text-[#b4462a] underline">Contact us</Link>.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
